<template>
  <div :id="myChartId" ref="canvas" style="height: 30px;"></div>
</template>

<script>
  // import $ from 'jquery'
  export default {
    name: "EberFollowBar",
    props: {
      maxData: {
        type: Number,
        default() {
          return 1
        }
      },
      followupData: {
        type: Object,
        default () {
          return {oid: 0, oname: '无', total: 0, already: 0, finish: 0, fail: 0};
        }
      }
    },
    data () {
      return {
        myChartId: this.followupData.oid,
        myChart: null,
      }
    },
    created() {
    },
    mounted(){
      this.drawBar();
      let _self = this;
      this.drawBar();
      window.addEventListener('resize', function () {
        $('#' + _self.myChartId).width($(window).width() * 0.82 - 250);
        _self.myChart.resize()
      })
    },
    watch:{
      followupData(){
        this.changeBar();
      },
    },
    methods: {
      drawBar(){
        let that = this;
        $('#' + that.myChartId).width($(window).width() - 280 - 80 - 250);
        that.myChart = that.$echarts.init(that.$refs.canvas);
        // 绘制图表
        that.myChart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            },
            position:  (point, e, dom) => {
              const echartsId = '#' + that.myChartId;
              let paddingScreeLeft = $(echartsId).offset().left;
              let paddingScreetop = $(echartsId).offset().top;
              $(dom).css('position', 'fixed');
              return [point[0] + paddingScreeLeft + 5, point[1] + Math.abs(paddingScreetop)];
            },
          },
          grid: {
            x: 1,
            y: 1,
            x2: 1,
            y2: 1,
            borderWidth: 1,
          },
          xAxis:  {
            type: 'value',
            show:false,
            max: that.maxData
          },
          yAxis: {
            type: 'category',
            data: [that.followupData.oname],
            show: false
          },
          series: [
            {
              name: '出院患者',
              type: 'bar',
              itemStyle: {
                normal: {
                  color: '#F2F2F2'
                }
              },
              barGap: '-100%',
              data: [that.followupData.total]
            },
            {
              name: '计划',
              type: 'bar',
              itemStyle: {
                normal: {
                  color: '#61A8E8'
                }
              },
              barGap: '-100%',
              data: [that.followupData.already]
            },
            {
              name: '完成',
              type: 'bar',
              itemStyle: {
                normal: {
                  color: '#7ECF51'
                }
              },
              barGap: '-100%',
              data: [that.followupData.finish]
            },
            {
              name: '不良',
              type: 'bar',
              itemStyle: {
                normal: {
                  color: '#EECB5F'
                }
              },
              barGap: '-100%',
              data: [that.followupData.fail]
            }]
        });
        that.myChart.resize();
      },
      changeBar() {
        let that = this;
        that.myChart.setOption({
          xAxis:  {max: that.maxData},
          yAxis:  {data: [that.followupData.oname]},
          series: [
            {data: [that.followupData.total]},
            {data: [that.followupData.already]},
            {data: [that.followupData.finish]},
            {data: [that.followupData.fail]}]
        });
        that.myChart.resize();
      }
    }
  }
</script>

<style scoped>
</style>
